<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2025-03-25 11:36:16
 -->
<template>
  <div class="select-picker">
    <van-popup
      v-model="visible"
      position="bottom"
      :close-on-click-overlay="closeOnClickOverlay"
    >
      <van-picker
        show-toolbar
        :value-key="valueKey"
        :columns="columns"
        :default-index="defaultIndex"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Picker } from "vant";
export default {
  name: "SelectPicker",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  props: {
    closeOnClickOverlay: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: "Text",
    },
    height: {
      type: String,
      default: "50%",
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultValue: {
      type: [Number, String],
      default: "",
    },
    change: { type: Function },
    cancel: { type: Function },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    defaultIndex() {
      const index = this.columns.findIndex(p => p.Id == this.defaultValue);
      return index > -1 ? index : 0;
    },
  },
  created: function() {},
  mounted() {
    this.visible = true;
  },

  methods: {
    onConfirm(data) {
      this.$emit("change", data);
      this.visible = false;
      this.$emit("destroy");
    },
    onCancel() {
      this.visible = false;
      this.$emit("cancel");
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less"></style>
